import { render } from "./materialList.vue?vue&type=template&id=f698c496"
import script from "./materialList.vue?vue&type=script&lang=js"
export * from "./materialList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__